import { Component, input } from '@angular/core';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';

import { CommodityOfferLabelComponent } from '../../shared/commodity-offer-label/commodity-offer-label.component';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

@Component({
  selector: 'essent-commodity-offer-header',
  templateUrl: './commodity-offer-header.component.html',
  styleUrls: ['./commodity-offer-header.component.essent.scss'],
  standalone: true,
  imports: [
    DefaultComponentModule,
    CSCaptureDirective,
    CommodityOfferLabelComponent,
    RoundedCurrencyPipe,
  ],
})
export class CommodityOfferEssentHeaderComponent {
  readonly duration = input<string>();
  readonly productTitle = input<string>();
  readonly price = input<number>();
  readonly priceDurationLabel = input<string>();
  readonly priceDurationAlternateLabel = input<string>();
  readonly withDiscountAlternateLabel = input<string>();
  readonly incentive = input<string>();
  readonly highlight = input<string>();
  readonly promoCode = input<string>();
  readonly addLabelSpacer = input(false);
  readonly floatingIncentive = input(true);
  readonly showPriceTag = input.required<boolean>();
  readonly isDynamicProduct = input(false);
  readonly dynamicPricingTitle = input<string>();
  readonly enableNewOfferCardTitles = input<boolean>();
  readonly termijnbedragVariantA = input(false);
  readonly termijnbedragVariantB = input(false);
}
